export function toText(value: unknown): string {
  if (value === null) {
    return '';
  }
  return String(value).trim();
}
